export const APP = "app"
export const PRICEING_RULES = "/dashboard/pricing-rules"
export const ADD_PRICING_RULE = "/dashboard/add-pricing-rule"
export const UPDATE_PRICING_RULE = "/dashboard/update-pricing-rule"
export const CALCULATE_PRICE = "/dashboard/calculate-price"
export const RULES_SETTINGS = "/dashboard/rules-settings"
export const REBATES = "/dashboard/rebates"
export const LOYALTY = "/dashboard/loyalty"
